import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IoniconsOutline, NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item-toogle',
  template: `
    <div
      (click)="clickItem.emit(item)"
      class="sidebar-toogle"
      [ngClass]="{ 'sidebar-toogle--collapsed': collapsed }"
    >
      <pt-icon
        [key]="collapsed ? IconExpand : IconCollapse"
        [size]="16"
      ></pt-icon>
      <label *ngIf="!collapsed">{{
        (collapsed ? 'SIDEBAR.EXPAND' : 'SIDEBAR.COLLAPSE') | translate
      }}</label>
    </div>
  `,
  styles: [
    `
      .sidebar-toogle {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        flex-direction: row;
        width: 100%;
        height: 36px;
        cursor: pointer;
      }

      .sidebar-toogle * {
        cursor: pointer;
      }

      .sidebar-toogle:hover {
        opacity: 0.8;
      }

      .sidebar-toogle:focus {
        outline: none;
      }

      .sidebar-toogle pt-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
      }

      .sidebar-toogle label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0;
        width: 100%;
      }

      .sidebar-toogle--collapsed {
        background: #e9e9e9;
        color: var(--bs-dark);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    `,
  ],
})
export class SidebarItemToogleComponent implements OnInit {
  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Output() clickItem = new EventEmitter<NavItem>();

  IconCollapse = IoniconsOutline.collapse;
  IconExpand = IoniconsOutline.expand;

  T = NavItemsType;
  isEnabled = true;

  constructor(private permissionService: NgxPermissionsService) {}

  ngOnInit(): void {
    this.permissionService
      .hasPermission(this.item.permissEnabled)
      .then((enabled) => {
        this.isEnabled = enabled;
      });
  }
}
